import { useMutation } from "@tanstack/react-query";
import { Text } from "@ui-kitten/components";
import Button from "components/Button";
import Dialog, { DialogProps } from "components/Dialog";
import { EventAvailabilityDetails } from "features/types";
import { useAccount } from "hooks/useAccount";
import useCurrentUser from "hooks/useCurrentUser";
import { updateAccountMemberRequest } from "queries/account.queries";
import React from "react";
import { View } from "react-native";
import toast from "utils/toast";

interface TDCDialogProps extends DialogProps {
  event: EventAvailabilityDetails;
}

const TDCDialog: React.FC<TDCDialogProps> = ({
  visible,
  setVisible,
  onOk,
  event,
  ...rest
}) => {
  const { currentUser } = useCurrentUser(); // we know we are primary member if the dialog is open
  const { account, fetchAccount } = useAccount();
  const { mutateAsync: updateAccountMember, isLoading: updatingAccountMember } =
    useMutation(updateAccountMemberRequest);
  const { currentMember } = useCurrentUser();

  const handleUpdateAccountMember = async () => {
    try {
      await updateAccountMember({
        accountId: account!.id,
        memberId: currentMember!.id,
        extUsername: currentMember!.user.email,
        ticketProvider: event.ticketProvider,
        barcodeProvider: event.barcodeProvider,
      });
      toast.success(
        "Great! We have successfully linked your MLB Account. You may now begin making your first reservation."
      );
      fetchAccount();
    } finally {
      setVisible!(false);
    }
  };

  if (!currentUser) return null;
  return (
    <Dialog visible={visible} setVisible={setVisible} {...rest}>
      <Text category="h6">Link your MLB Ballpark account</Text>
      <Text style={{ marginVertical: 10 }}>
        Your entry barcodes will be delivered to your mobile device, inside the
        MLB Ballpark app.
      </Text>

      <Text>
        To make your first reservation, first we need to link your MLB Ballpark
        account
      </Text>

      <View style={{ marginVertical: 10 }}></View>

      <View>
        <Text>
          Please ensure you are either logged into the MLB Ballpark app with the
          email address listed below, or add it to your MLB Verified Emails in
          the account settings.
        </Text>
        <Text style={{ marginVertical: 15, fontWeight: "700" }}>
          {currentUser.email}
        </Text>
        <Button
          loading={updatingAccountMember}
          style={{ alignSelf: "flex-start" }}
          onPress={handleUpdateAccountMember}
        >
          Link MLB Account
        </Button>
      </View>
    </Dialog>
  );
};

export default TDCDialog;
